import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { canAuthor } from '../../../helpers/userAuth';
import { selectCurrentUser } from '../../../selectors/authSelectors';

const AuthorViewLearning3kLesson = ({ lessonId }) => {
  const currentUser = useSelector(selectCurrentUser);
  const isAuthor = canAuthor(currentUser);

  if (!isAuthor) {
    return null;
  }

  if (!lessonId) {
    return null;
  }

  const handleClick = () => {
    const railsUrl = `/learning/lesson_preview/${lessonId}`;
    window.open(railsUrl, '_blank');
  };

  return (
    <button className="header-bar__edit-3k" onClick={handleClick}>
      L3k View
    </button>
  );
};

AuthorViewLearning3kLesson.propTypes = {
  lessonId: PropTypes.string.isRequired,
};

export default AuthorViewLearning3kLesson;
